import TR from 'utils/TR';
import Header from 'components/header';
import T from 'utils/T';
import ex from 'utils/ex';
import ReportTabs from '../ReportTabs';
import ExerciseSummary from './ExerciseSummary';
import ExerciseAnalysis from './ExerciseAnalysis';
import ExercisePattern from './ExercisePattern';
import ExerciseStatistics from './ExerciseStatistics';
import PageContent from '../../PageContent';
import VBox from 'components/common/VBox';
import Division from 'components/common/Division';
import PageTitle from '../../PageTitle';

import React from 'react';


import Segment from 'components/common/Segment';
import DIRECTION_VERTICAL from 'constants/DIRECTION_VERTICAL';
import GuideButton from '../GuideButton';
import FocusableButton from 'components/common/FocusableButton';
import useReportActiveStep from 'hooks/communication/useReportActiveStep';

import Recoil from 'recoil';
import * as AppStore from 'stores/AppStore';

import useReportActiveCalory from 'hooks/communication/useReportActiveCalory';
import { useSignal } from 'modules/Signals';

const viewMode = 'ReportExerciseCalories';
export default function ReportExerciseCalories(props) {
  const {
    renderAll,
    front,
    ...rest
  } = props;

  const {
    requestReportActiveStep,
  } = useReportActiveStep();
  const {
    requestReportActiveCalory,
  } = useReportActiveCalory();

  const signal = useSignal();
  // const [caloryData, setCaloryData] = React.useState({});

  const [data, setData] = Recoil.useRecoilState(AppStore.assets.data('ReportExerciseCalories'));
  const period_start = Recoil.useRecoilValue(AppStore.assets.period_start);
  const period_end = Recoil.useRecoilValue(AppStore.assets.period_end);
  const patient_no = Recoil.useRecoilValue(AppStore.assets.patient_no);

  React.useEffect(() => {
    requestReportActiveCalory({
      patient_no,
      search_start_time: period_start,
      search_end_time: period_end,
    }, (success, data) => {
      if (success) {
        setData(() => data);
      } else {
        setData(() => ({}));
      }
    });
  }, [patient_no, period_end, period_start, requestReportActiveCalory, setData]);

  React.useEffect(() => {
    if (!front) return;
    signal('ReportData', data, 'ReportExerciseCalories');
  }, [front, data, signal]);

  return (
    <div {...ex(['Page', 'ReportExerciseCalories'], rest)}>

      <PageContent>
        <VBox full>
          <Division>
            <ExerciseSummary {...{ viewMode, caloryData: data }} />
          </Division>
          <Segment {...{ direction: DIRECTION_VERTICAL }}>
            <ExercisePattern {...{ viewMode, caloryData: data, duration: renderAll ? 0 : 1 }} />
            <ExerciseAnalysis key={data.uninitialized} {...{ viewMode, caloryData: data, duration: renderAll ? 0 : 1 }} />
          </Segment>
          <Segment {...{ direction: DIRECTION_VERTICAL }}>
            <ExerciseStatistics {...rest} {...{ viewMode, data, duration: renderAll ? 0 : 1 }} />
          </Segment>
          <GuideButton {...rest} {...{ type: 'exercise' }} />
        </VBox>
      </PageContent>
    </div >
  );
}
